import { createOrphanRefusal } from "@/components/shipments/confirm-address-refusal"

/**
 * OKS-1040 (PO p4c-02a) — a « Choisir pour le créateur » refusal whose dialog
 * is gone.
 *
 * The race: the creator picks while the brand's choose dialog is open. The
 * server correctly refuses the brand (`already_chosen`, nothing written, 302 +
 * `errors.base`) — but the creator's pick settled the row, so the reloaded
 * props move it Waiting → Ready: the Waiting row unmounts, `ProductChoiceDialog`
 * with it, and its refusal Alert had nowhere to render. Third instance of the
 * OKS-1037 D1 shape, on its own context so the doors' refusals never mix.
 *
 *   dialog still open  → the dialog's own Alert shows it (and « Fermer »)
 *   dialog unmounted   → the page shows it, once, above the queue
 */
// inertia-i18n-use shipments.product_choice.close
const productChoice = createOrphanRefusal({
  testIdPrefix: "shipments-product-choice",
  closeKey: "shipments.product_choice.close",
})

export const ProductChoiceRefusalProvider = productChoice.Provider
export const useProductChoiceRefusal = productChoice.useRefusal
